<template>
  <div>

    <a  @click="fnShowModal()" class="p-2"><i class="far fa-edit text-primary"></i></a>

    <b-modal ref="modal" hide-footer title="Pay period">
        <div class="d-block">
          <form>

            <div class="form-group">
              <label for="period">Period</label>
              <input type="text" 
              class="form-control" 
              id="period" 
              placeholder="Pay period"
              v-model="period">
              <div class="invalid-feedback" v-if="errors.period">{{ errors.period[0] }}</div>
            </div>
           <b-form-checkbox
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
                >
                Status
            </b-form-checkbox>
          <hr>
          <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button  type="button" @click="fnUpdate()" class="btn btn-success btn-sm">Update</button>
          </div>
          </form>
        </div>
      </b-modal>
  </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as payPeriodService from '../../services/payPeriod.service';
    export default {
        name:"ModelPayPeriodEdit",
        props:['propsData'],
        components: {
            
        },
        data(){
            return{
                errors:{},
                id:'',
                period:'',
                status:'',
            }
        },
        computed:{
            ...mapGetters(['gettPayPeriodAll']),
        },
        methods:{
            ...mapActions(['fetchPayPeriodAll']),
            fnShowModal(){
                this.fnGetValue(this.propsData)
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            fnGetValue(props){
                this.id = props.rowData.id;
                this.status = props.rowData.status;
                this.period = props.rowData.period;
            },

            fnUpdate:async function(){
                const obj = {
                    "period":this.period,
                    "status":this.status
                }

                try{
                    const response = await payPeriodService.update(this.id, obj);
                    this.fetchPayPeriodAll();
                    messageService.fnSweetAlertSuccessToast('Pay period', 'Updated successfully ');
                    this.hideModal();

                }catch(error){
                    messageService.fnSweetAlertErrorToast('Pay period - update', error.response.data.message);
                }

                this.id = ''; 
                this.period = '';
                this.status ='';
            }
        }
    }
</script>